export const TEMPLATE_CARD_MIN_HEIGHT = "min-h-[50px]";
export const TEMPLATE_CARD_BASE = `flex h-full ${TEMPLATE_CARD_MIN_HEIGHT} flex-col`;
